import PriceAndHeadingSection from "./PriceAndHeadingSection";

export default PriceAndHeadingSection;
